export default {
  isIdentifier: function (text) {
    return /^\w+$/.test(text)
  },
  isMobilePhone: function (text) {
    return /^1\d{10}$/.test(text)
  },
  isPhone: function (text) {
    return /^(\d{3,6}[-_])?\d{6,12}$/.test(text)
  },
  isZipCode: function (text) {
    return /^\d{6}$/.test(text)
  },
  isEmail: function (text) {
    return /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(text)
  },
  isQQ: function (text) {
    return /^\d{4,20}$/.test(text)
  },
  isIdCard: function (text) {
    return /^(\d{17}[\dXx]|\d{15})$/.test(text)
  }
}
